import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lost } from "@/components/sheet/Lost";

/* Any URL no route claims: the loose strip, the line, one plate home (DESIGN.md §10). */
const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Lost
      mark={
        <Link to="/" className="sh-wordmark">
          aSTRING
        </Link>
      }
      title={t("errors.notFound.title")}
      body={t("errors.notFound.body")}
    >
      <Link to="/" className="sh-plate">
        {t("errors.notFound.home")}
      </Link>
    </Lost>
  );
};

export default NotFoundPage;
